import Api from "..";

const normalizeFrequencyLabel = (frequency) => {
    if (typeof frequency !== 'string' || !frequency.trim()) return 'Todas as semanas do mês';

    const canonicalByKey = {
        'todas as semanas do mes': 'Todas as semanas do mês',
        'todas as semanas': 'Todas as semanas do mês',
        'primeira semana do mes': 'Primeira semana do mês',
        'primeira semana': 'Primeira semana do mês',
        'segunda semana do mes': 'Segunda semana do mês',
        'segunda semana': 'Segunda semana do mês',
        'terceira semana do mes': 'Terceira semana do mês',
        'terceira semana': 'Terceira semana do mês',
        'ultima semana do mes': 'Última semana do mês',
        'ultima semana': 'Última semana do mês',
        'duas primeiras semanas do mes': 'Duas primeiras semanas do mês',
        'duas primeiras semanas': 'Duas primeiras semanas do mês',
        'duas ultimas semanas do mes': 'Duas últimas semanas do mês',
        'duas ultimas semanas': 'Duas últimas semanas do mês'
    };

    const key = frequency
        .trim()
        .replace(/\s+/g, ' ')
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase();
    const keyWithoutApenas = key.replace(/^apenas\s+(a\s+)?/, '');

    return canonicalByKey[keyWithoutApenas] || canonicalByKey[key] || frequency.trim();
};

/**
 * Remove disponibilidades duplicadas do array
 * Considera duplicada quando usuario, ponto, dia, periodo, frequencia e horarios são idênticos
 */
const removerDisponibilidadesDuplicadas = (disponibilidades) => {
    const map = new Map();
    
    disponibilidades.forEach(disp => {
        // Cria uma chave única baseada nos campos que definem uma disponibilidade
        const horariosSorted = [...(disp.horario || [])].sort().join(',');
        const key = [
            disp.usuario?._id || disp.usuario,
            disp.ponto?._id || disp.ponto,
            disp.dia,
            disp.periodo,
            normalizeFrequencyLabel(disp.frequencia),
            horariosSorted
        ].join('|');
        
        // Mantém apenas a primeira ocorrência (ou a mais recente se quiser usar createdAt)
        if (!map.has(key)) {
            map.set(key, disp);
        }
    });
    
    return Array.from(map.values());
};

const getDisponibilidades = async () => {
    try {
        const response = await Api.get("disponibilidade/listarDisponibilidades");
        const normalizadas = (response.data || []).map((disp) => ({
            ...disp,
            frequencia: normalizeFrequencyLabel(disp?.frequencia),
        }));
        // Remove duplicatas antes de retornar
        return removerDisponibilidadesDuplicadas(normalizadas);
    } catch (error) {
        throw new Error(`Erro ao buscar disponibilidades: ${error.message}`);
    }
};

const getDisponibilidadeById = async (id) => {
    try {
        const response = await Api.get(`/disponibilidade/buscarDisponibilidadePorId?id=${id}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar disponibilidade com ID ${id}: ${error.message}`);
    }
};

const createDisponibilidade = async (disponibilidadeData) => {
    try {
        const response = await Api.post("/disponibilidade/criarDisponibilidade", disponibilidadeData);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao criar disponibilidade: ${error.message}`);
    }
};

const updateDisponibilidade = async (id, disponibilidadeData) => {
    try {
        const response = await Api.patch(`/disponibilidade/atualizarDisponibilidade?id=${id}`, disponibilidadeData);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao atualizar disponibilidade com ID ${id}: ${error.message}`);
    }
};

const deleteDisponibilidade = async (id) => {
    try {
        const response = await Api.delete(`/disponibilidade/deletarDisponibilidade?id=${id}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao deletar disponibilidade com ID ${id}: ${error.message}`);
    }
};

export default {
    getDisponibilidades,
    getDisponibilidadeById,
    createDisponibilidade,
    updateDisponibilidade,
    deleteDisponibilidade
};
